/**
 * 头部组件
 */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Badge, Modal, Avatar, message, List, Form, Input, Button, Space } from 'antd';
import { useHistory } from 'react-router-dom';
import { INITSTATE } from 'src/store/common/collapsed';
import useFetchState from 'src/utils/useFetchState';
// import Lang from 'src/components/common/language';
import { LangMessage } from 'src/store/common/language';
// import logoTitle from 'src/assets/imgs/common/head_logo.png';
// import overseas from 'src/assets/imgs/common/overseas.png';
import { NEW_TOGGLE, ACTION, NEWS_ADD, NEWS_CLEAR, NEWS_COUNT_CLEAR, NEWS_COUNT_ADD } from 'src/store/common/news';
import { MENUTABS_DELETE_ALL } from 'src/store/common/menuTabs';
import bus from 'src/utils/eventBus';
import { common, user } from 'src/api';
import { CLEAR_LOGIN, ACTION as UserACTION} from 'src/store/common/user';
import newsNotice from './newsNotice';
import { MENUTABS_ADD } from 'src/store/common/menuTabs';
import HeadIcon from 'src/assets/imgs/common/usernameimg.png';
import { COLLAPSED_TOGGLE } from 'src/store/common/collapsed';
import { debounce } from 'lodash';
import CustomIcon from 'src/components/common/icon/customIcon';

interface Props extends INITSTATE {
    dispatch: React.Dispatch<any>;
    Mes: LangMessage;
    newsShow: boolean;
    username: string;
    email: string;
    phone: string;
    ip: string;
    operatorName: string;
    newsCount: number;
    subSysNo: string;
    nodeNo: string[];
    operatorType: string;
    wsState?: boolean;
}

type Userprops = {
    Mes: LangMessage;
    eventLeave: () => void;
    username: string;
    eventEnter: () => void;
    dispatch: React.Dispatch<ACTION | UserACTION>;
    openUpdateUserInfo: () => void;
    operatorType: string;
    ip: string;
};

type Cache = {
    count: number;
    flag: boolean;
}

const UserMgt: React.FC<Userprops> = (userprops) => {
    const { Mes, eventLeave, eventEnter, username, dispatch, openUpdateUserInfo, operatorType, ip } = userprops;

    const history = useHistory();

    // 退出登陆
    const loginOut = async () => {
        try {
            await user.logout();
            dispatch({
                type: CLEAR_LOGIN,
                value: false,
            });
            dispatch({
                type: MENUTABS_DELETE_ALL,
                value: true,
            });
            dispatch({
                type: COLLAPSED_TOGGLE,
                value: true,
            });
            history.push('/login');
            setTimeout(() => {
                location.reload();
            }, 0);
        } catch (error: any) {
            message.error(error);
        }
    };

    // 修改信息
    const changeInfo = async () => {
        if (typeof openUpdateUserInfo === 'function') {
            openUpdateUserInfo();
        }
    };

    // 打开帮助弹窗
    const openHelp = async () => {
        let res: any = null;

        try {
            res = await common.getSystemVersion();
        } catch (e) {
            console.error(e);
            message.warning(Mes['labelTitleWentWrong']);
        }
        const infoList = [
            {
                label: Mes['mainDialogIpip'],
                text: ip,
            },
            {
                label: Mes['titleLabelRecommendResolution'],
                text: '1920*1080',
            },
            {
                label: Mes['labelTitleSystemVersion'],
                text: res?.data[0]?.PARAMETER_VALUE || '',
            },
            {
                label: Mes['labelTitleSystemBuildTime'],
                text: res?.data[1]?.PARAMETER_VALUE || '',
            },
            {
                label: window.config.project === 'MDR' ? Mes['mainDialogHelphelp'] : Mes['mainDialogPVMShelp'],
                text: 'User Manuals.zip',
            },
        ];

        Modal.info({
            className: 'helpModel',
            title: <p>{Mes['labelTitleHelp']}</p>,
            width: 520,
            content: (
                <List
                    size='large'
                    itemLayout='horizontal'
                    dataSource={infoList}
                    renderItem={(item, index) => (
                        <List.Item key={index}>
                            <span className='label'>{item.label}:</span>
                            {index === infoList.length - 1 ? (
                                <a href={window?.config?.helpUrl || ''} target='_blank' download className='onColor' rel='noreferrer'>
                                    {item.text}
                                </a>
                            ) : (
                                <span className='text'>{item.text}</span>
                            )}
                        </List.Item>
                    )}
                />
            ),
        });
    };


    // 修改密码
    const changePassword = () => {
        history.push('/login', { username: username });
    };

    return (
        <>
            <ul className='user-mgnt' onMouseEnter={eventEnter} onMouseLeave={eventLeave}>
                {
                    operatorType === '0' ? <li key='1' onClick={changePassword} title={Mes['btnTextChangePassword']}>
                        {Mes['btnTextChangePassword']}
                    </li> : null
                }

                {window?.config?.project === 'PVMS' ? (
                    <li key='2' onClick={changeInfo} title={Mes['titleTableChangeaccmsgchangeaccmsg']}>
                        {Mes['titleTableChangeaccmsgchangeaccmsg']}
                    </li>
                ) : null}
                <li key='4' title={Mes['labelTitleHelp']} onClick={openHelp}>
                    {Mes['labelTitleHelp']}
                </li>
                <li onClick={loginOut} key='3' title={Mes['btnTextSignOut']}>
                    {Mes['btnTextSignOut']}
                </li>
            </ul>
        </>
    );
};

const Header: React.FC<Props> = (props) => {
    const { dispatch, Mes, newsShow, username, ip, newsCount: newsNum, operatorName, phone, email, operatorType, wsState } = props;

    const cache = useRef<Cache>({count: newsNum, flag: false});
    const [ userMgtShow, setUserMgtShow ] = useFetchState<boolean>(false);
    const [ visible, setVisible ] = useFetchState<boolean>(false);
    const [ loading, setLoading ] = useFetchState<boolean>(false);
    const [ newsCount, setNewsCount ] = useFetchState<number>(newsNum || 0);
    const history = useHistory();
    const [ form ] = Form.useForm();

    // 打开消息列表弹窗
    const openNews = () => {
        if (window.config.project === 'MDR') {
            dispatch({
                type: NEWS_COUNT_CLEAR,
            });
            cache.current.count = 0;
            dispatch({
                type: NEW_TOGGLE,
                value: !newsShow,
            });
        } else {
            dispatch({
                type: MENUTABS_ADD,
                value: {
                    key: 'Remote Task Mgnt',
                    title: 'menuTitleRemoteTaskMgnt',
                    route: '/home/prepaidFunction/remoteTaskMgnt',
                },
            });
            history.push('/home/prepaidFunction/remoteTaskMgnt');
        }
    };

    // 鼠标移入头像显示下拉列表，操作退出修改密码等
    const eventMouseOver = () => {
        setUserMgtShow(true);
        cache.current.flag = true;
    };

    const closeUserOut = debounce(() => {
        if (!cache.current.flag) {
            setUserMgtShow(false);
        }
    }, 666);

    const eventMouseOut = () => {
        cache.current.flag = false;
        closeUserOut();
    };

    const openUserInfo = () => {
        setVisible(true);
    };

    const update = async () => {
        setLoading(true);
        try {
            const data = form.getFieldsValue();

            await user.checkPassword(data.password || '');
            Modal.confirm({
                title: Mes['messageSuccessConfirmconfirm'],
                content: Mes['messageConifgSureChangeAccount'],
                async onOk () {
                    try {
                        await user.updateAccountMsg(data);
                        setVisible(false);
                    } catch (error) {
                        message.error(typeof error === 'string' ? error : Mes['messageAlarmRequestfailrequestfail']);
                    }
                    setLoading(false);
                },
                onCancel () {
                    setLoading(false);
                },
            });
        } catch (error) {
            setLoading(false);
            message.error(typeof error === 'string' ? error : Mes['messageAlarmRequestfailrequestfail']);
        }
    };

    // 获取websocket数据
    useEffect(() => {
        bus.on('meterAlarm', async (row: any) => {
            try {
                const counts = cache.current.count + 1;

                dispatch({
                    type: NEWS_COUNT_ADD,
                    value: counts,
                });
                cache.current.count = counts;

                newsNotice({
                    row: {
                        deviceNo: row?.deviceInfo?.deviceNo,
                        deviceAddr: row?.deviceInfo?.deviceAddress,
                        etime: row?.alarmInfo?.alarmTime,
                    },
                    type: 'alarm',
                    title: `[${row?.alarmInfo?.alarmId}]${row?.alarmInfo?.alarmDesc}`,
                    Mes: Mes,
                });
                const { dataStatus } = row?.alarmInfo;

                let dataState = typeof dataStatus === 'undefined' ? 1 : dataStatus;

                dispatch({
                    type: NEWS_ADD,
                    value: {
                        TITLE: `[${row?.alarmInfo?.alarmId}]${row?.alarmInfo?.alarmDesc}`,
                        EVENT_DESC: row?.alarmInfo?.alarmDesc,
                        EVENT_ID: row?.alarmInfo?.alarmId || '',
                        ALARM_TYPE: 'Meter-Alarm',
                        DEVICE_ADDRESS: row?.deviceInfo?.deviceAddress || '',
                        OCCUR_DATETIME: (dataState ? row?.alarmInfo?.alarmTime : row?.alarmInfo?.receiveTime) || '', // dataStatus = 1时，时间取alarmTime，为0时取receiveTime
                        SN: row.alarmInfo?.id || '',
                        DEVICE_NO: row?.deviceInfo?.deviceNo || '',
                        TYPE: row?.alarmType,
                        dataStatus: dataState,
                    },
                });
            } catch (error: any) {
                console.error(error.toString());
                message.error(error.toString());
            }
        });
        bus.on('dcuAlarm', async (row: any) => {
            try {
                const counts = cache.current.count + 1;

                dispatch({
                    type: NEWS_COUNT_ADD,
                    value: counts,
                });
                cache.current.count = counts;

                newsNotice({
                    row: {
                        deviceNo: row?.deviceInfo?.deviceNo,
                        deviceAddr: row?.deviceInfo?.deviceAddress,
                        etime: row?.alarmInfo?.alarmTime,
                    },
                    type: 'alarm',
                    title: `[${row?.alarmInfo?.alarmId}]${row?.alarmInfo?.alarmDesc}`,
                    Mes: Mes,
                });
                const { dataStatus } = row?.alarmInfo;

                let dataState = typeof dataStatus === 'undefined' ? 1 : dataStatus;

                dispatch({
                    type: NEWS_ADD,
                    value: {
                        TITLE: `[${row?.alarmInfo?.alarmId}]${row?.alarmInfo?.alarmDesc}`,
                        ALARM_TYPE: 'DCU-Alarm',
                        DEVICE_ADDRESS: row?.deviceInfo?.deviceAddress || '',
                        OCCUR_DATETIME: (dataState ? row?.alarmInfo?.alarmTime : row?.alarmInfo?.receiveTime) || '', // dataStatus = 1时，时间取alarmTime，为0时取receiveTime
                        SN: row.alarmInfo?.id || '',
                        EVENT_DESC: row?.alarmInfo?.alarmDesc || '',
                        EVENT_ID: row?.alarmInfo?.alarmId || '',
                        DEVICE_NO: row?.deviceInfo?.deviceNo || '',
                        TYPE: row?.alarmType,
                        dataStatus: dataState,
                    },
                });
            } catch (error: any) {
                console.error(error.toString());
                message.error(error.toString());
            }
        });
        bus.on('deviceOnOff', async (row: any) => {
            try {
                newsNotice({
                    row: {
                        deviceNo: row.dcuId,
                        etime: row.eTime,
                        deviceAddr: '',
                    },
                    type: 'onOff',
                    title: Mes[row.status === 'off' ? 'textDeviceOffline' : 'textDeviceOnline'],
                    Mes: Mes,
                });
            } catch (error: any) {
                console.error(error.toString());
                message.error(error.toString());
            }
        });
        bus.on('error', async (row: any) => {
            console.error(row);
        });
        return () => {
            // 离开页面销毁监听
            bus.removeAllListeners('dcuAlarm');
            bus.removeAllListeners('deviceOnOff');
            bus.removeAllListeners('meterAlarm');
        };
    }, []);

    const clearNews = () => {
        dispatch({
            type: NEWS_COUNT_CLEAR,
        });
        dispatch({
            type: NEWS_CLEAR,
            value: null,
        });
    };

    const connectWs = () => {
        if (!wsState) {
            bus.emit('connection', true);
        }
    };

    // 刷新事件监听
    useEffect(() => {
        window.addEventListener('beforeunload', clearNews);
        return () => {
            window.removeEventListener('beforeunload', clearNews);
        };
    });

    useEffect(() => {
        if (!username) {
            dispatch({
                type: CLEAR_LOGIN,
                value: false,
            });
            history.push('/login');
            setTimeout(() => {
                location.reload();
            }, 0);
        }
    }, [ username ]);

    useEffect(() => {
        setNewsCount(newsNum);
    }, [ newsNum ]);

    return (
        <>
            <Space align='center' className='page-header'>
                <CustomIcon IconName={!wsState ? 'WSConnectSVG' : 'WSUNConncetSVG' } onClick={connectWs} />
                {/* 消息 */}
                <a href='#' onClick={openNews} className='news' title={Mes['labelTitleNews']}>
                    <Badge count={newsCount} showZero>
                        <CustomIcon IconName='NEWSSVG' />
                    </Badge>
                </a>
                {/* 用户信息 */}
                <div className='user'>
                    <Space className='username' align='center' onMouseEnter={eventMouseOver} onMouseLeave={eventMouseOut}>
                        <Avatar src={HeadIcon} size={40} />
                        <span>{operatorName}</span>
                    </Space>
                    {userMgtShow && <UserMgt
                        dispatch={dispatch}
                        username={username}
                        Mes={Mes}
                        openUpdateUserInfo={openUserInfo}
                        eventEnter={eventMouseOver}
                        operatorType={operatorType}
                        ip={ip}
                        eventLeave={eventMouseOut} />}
                </div>
            </Space>
            <Modal
                title={Mes['titleTableChangeaccmsgchangeaccmsg']}
                className='changeInfo'
                visible={visible}
                onOk={update}
                onCancel={() => setVisible(false)}
                footer={[
                    <Button key='back' onClick={() => setVisible(false)}>
                        { Mes['titleLabelCloseclose']}
                    </Button>,
                    <Button key='submit' type='primary' loading={loading} onClick={update}>
                        { Mes['btnSubmit'] }
                    </Button>,
                ]}
            >
                <Form form={form}
                    name='accountInfo'
                    initialValues={{
                        phone: phone || '',
                        email: email || '',
                    }}
                    labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                    <Form.Item label={Mes['titleTablePhonephone']} name='phone'>
                        <Input type='text' autoComplete='off' />
                    </Form.Item>
                    <Form.Item label={Mes['titleTableEmailemail']} name='email' rules={[ { type: 'email' } ]}>
                        <Input type='email' autoComplete='off' />
                    </Form.Item>
                    <Form.Item label={Mes['titleTableYourpwsyourpws']} name='password' rules={[ { required: true } ]}>
                        <Input autoComplete='new-password' type='password' />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default connect((state: any) => ({
    collapsed: state.toggleCollapsed.collapsed,
    Mes: state.langSwitch.message,
    newsShow: state.toggleNews.newsShow,
    username: state.userInfo.sysUser.username,
    phone: state.userInfo.sysUser.phone,
    email: state.userInfo.sysUser.email,
    operatorName: state.userInfo.sysUser.operatorName,
    ip: state.userInfo.ip,
    subSysNo: state.userInfo.sysType,
    nodeNo: state.userInfo?.sysUser?.nodeNo,
    newsCount: state.newsCountDispath.newsCount,
    operatorType: state.userInfo.operatorType,
    wsState: state.connectWs.wsState,
}))(Header);
